/*
 *
 * Signup constants
 *
 */

export const CAPTION = [
  { value: 'By creating an account, you agree to our ', action: null },
  { value: 'User Agreement', action: 'agreement' },
  { value: ' and acknowledge reading our ', action: null },
  { value: 'User Privacy Notice', action: 'privacy' },
  { value: '.', action: null },
];
export const LOGIN_CAPTION = [
  { value: 'By proceeding, you agree to our ', action: null },
  { value: 'User Agreement', action: 'agreement' },
  { value: ' and ', action: null },
  { value: 'User Privacy Notice', action: 'privacy' },
  { value: '.', action: null },
];
export const MARKETING =
  'Yes, I want CredibleMind News and  Resource Updates. I understand I can unsubscribe at any time from My Profile or from emails.';
